/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_View_WeekInputs */

const en_platform_view_week = /** @type {(inputs: Platform_View_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week`)
};

const pl_platform_view_week = /** @type {(inputs: Platform_View_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tydzień`)
};

/**
* | output |
* | --- |
* | "Week" |
*
* @param {Platform_View_WeekInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_view_week = /** @type {((inputs?: Platform_View_WeekInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_View_WeekInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_view_week(inputs)
	return en_platform_view_week(inputs)
});